// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { BasicRole, BasicRoleSchema } from 'api/gen/BasicRole';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Breeder, BreederSchema } from 'api/gen/Breeder';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Farm, FarmSchema } from 'api/gen/Farm';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { PositiveInteger, PositiveIntegerSchema } from 'api/gen/PositiveInteger';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { User, UserSchema } from 'api/gen/User';

const requiredPart = t.interface({
  approvedFrom: DateSchema,
  approvedTo: t.union([DateSchema, t.null]),
  breeder: BreederSchema,
  farms: t.union([t.array(FarmSchema), t.null]),
  role: BasicRoleSchema,
  user: UserSchema,
  userProfileBreederRoleId: PositiveIntegerSchema,
});

export const UserProfileBreederRoleFarmsSchema = excess(requiredPart);

export interface UserProfileBreederRoleFarms extends t.TypeOf<typeof UserProfileBreederRoleFarmsSchema> {}
